import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StopPaymentConfirmPage, { getDefaultPageData } from "components/pages/StopPaymentConfirmPage";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureStopPaymentConfirm(props) {
    const globalController = useBCMSContext();
    const { branding } = useModel();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const data = BCMSStateManagerCRUD.init(getDefaultPageData(branding.options, globalController))
        .update([ "payment", "account" ], checkingAccount.id)
        .update([ "payment", "checkNumber" ], "123")
        .update([ "payment", "amount" ], "100")
        .update([ "payment", "reason" ], "Check Issued for Incorrect Amount")
        .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StopPaymentConfirmPage data={ data } className="for-capture"/>
}